import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Initialize controller
  }

  scrollRight() {
    const scrollAmount = window.innerWidth < 768 ? 240 : 300;
    this.containerTarget.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }

  scrollLeft() {
    const scrollAmount = window.innerWidth < 768 ? 240 : 300;
    this.containerTarget.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }
}